import { Stack } from '@mui/material';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';
import StatRow from './StatRow';
import { formatNumber } from './dashboardFormat';

const formatEuro = value =>
  `${(Number(value) || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

// Widget 5 — vouchers issued/redeemed by this flow (values in Euro).
export default function VoucherStatsWidget({ vouchers, loading, error, onRetry }) {
  const issued = Number(vouchers?.issued) || 0;
  const redeemed = Number(vouchers?.redeemed) || 0;
  const redemptionRate = issued > 0 ? Math.round((redeemed / issued) * 1000) / 10 : null;

  return (
    <DashboardWidgetCard
      title='Gutscheine'
      icon='CardGiftcard'
      accent='success'
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }} justifyContent='center'>
        <StatRow label='Ausgegeben' value={formatNumber(issued)} />
        <StatRow label='Ausgegebener Wert' value={formatEuro(vouchers?.issuedValue)} />
        <StatRow label='Eingelöst' value={formatNumber(redeemed)} />
        <StatRow label='Eingelöster Wert' value={formatEuro(vouchers?.redeemedValue)} />
        <StatRow
          label='Einlösequote'
          value={redemptionRate == null ? '—' : `${redemptionRate.toLocaleString('de-DE')} %`}
        />
      </Stack>
    </DashboardWidgetCard>
  );
}
